// Page-loading skeleton. Shown while the snapshot is being fetched AND as the
// Suspense fallback while a lazy page chunk (template / policy page) loads —
// the two states render pixel-identically, so a cold load reads as one
// continuous skeleton instead of a double flash.
//
// Mirrors the mini-site's real geometry (cover strip → centered avatar →
// name/handle → socials → tab pill → photo tiles) on the same page gradient,
// so content pops in exactly where the placeholders sat — no layout jump and
// no white flash. Blocks carry a soft shimmer sweep (.tz-skel in styles.css).
export function PageSkeleton() {
  return (
    <div
      className="relative mx-auto min-h-screen w-full max-w-screen-sm pb-24"
      style={{
        background:
          "radial-gradient(circle at top, #a9a9a9, #ebebeb 70%, #dcdcdc 100%)",
      }}
    >
      {/* Cover strip (HeroCenter: h-[130px]) */}
      <div className="tz-skel h-[130px] w-full" />

      {/* Avatar overlapping the cover, centered — matches h-24 w-24 ring */}
      <div className="relative -mt-12 flex flex-col items-center px-3">
        <div className="tz-skel h-24 w-24 rounded-full ring-4 ring-white/80" />
        <div className="tz-skel mt-4 h-5 w-40 rounded-md" />
        <div className="tz-skel mt-2 h-3.5 w-24 rounded-md" />
        <div className="tz-skel mt-3 h-3 w-72 max-w-[85%] rounded-md" />
        <div className="tz-skel mt-1.5 h-3 w-56 max-w-[70%] rounded-md" />

        {/* Social icon row */}
        <div className="mt-4 flex items-center gap-3">
          <div className="tz-skel h-9 w-9 rounded-full" />
          <div className="tz-skel h-9 w-9 rounded-full" />
          <div className="tz-skel h-9 w-9 rounded-full" />
          <div className="tz-skel h-9 w-9 rounded-full" />
          <div className="tz-skel h-9 w-9 rounded-full" />
        </div>
      </div>

      {/* Tab pill switcher */}
      <div className="mt-5 flex justify-center">
        <div className="tz-skel h-12 w-44 rounded-full" />
      </div>

      {/* Photo tiles (LinkTile: h-[120px] rounded-2xl) */}
      <div className="mt-4 grid gap-3 px-3">
        <div className="tz-skel h-[120px] w-full rounded-2xl" />
        <div className="tz-skel h-[120px] w-full rounded-2xl" />
        <div className="tz-skel h-[120px] w-full rounded-2xl" />
      </div>
    </div>
  )
}
